var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center flex-column h-100"},[_c('div',[_c('h1',{staticClass:"text-center"},[_vm._v("Sucesso!")]),_c('h3',[_vm._v("Aguarde, você está sendo redirecionado...")]),_c('Loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }